import { render } from "./LogBookCTCCorpPage.vue?vue&type=template&id=0b7a3bb4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__